import { calculatePeriod } from 'core/service/basic-plan'
import { queryPremiumRateForPBSDD as queryPremiumRate } from 'core/service/rider/query-premium-rate'
import { calculateRiderPremiumForPBPDD as calculateRiderPremium } from 'core/service/rider/premium-calculation'

const riderRules = {
  maximumPayerAge: {
    value: 70,
    unit: 'year',
  },
  payerAgeCoverage: 80,
}

const getYearsOfCoverage = (basicPaymentPeriod, insuredAge, payerAge, paymentPeriod) => {
  const _basicPaymentPeriod = Object.assign({}, basicPaymentPeriod)
  if (paymentPeriod) {
    _basicPaymentPeriod.value = paymentPeriod
  }
  const payerAgeValue = payerAge.unit !== 'year' ? 0 : payerAge.value
  const insuredAgeValue = insuredAge.unit !== 'year' ? 0 : insuredAge.value
  return Math.min(calculatePeriod(_basicPaymentPeriod, insuredAgeValue), riderRules.payerAgeCoverage - payerAgeValue)
}

const calculateMaximumPayerAge = () => {
  return riderRules.maximumPayerAge
}

export default {
  calculateRiderPremium,
  queryPremiumRate,
  getYearsOfCoverage,
  calculateMaximumPayerAge,
}
